module.exports = __webpack_public_path__ + "static/media/IC172Renew.cf4730f9.jpg";